import createActionType from "../../utils/createActionType";

export const MODULE = "planner/show-hide-order-filter";

export const SET_SELECTED_FILTER = createActionType(MODULE, "setSelectedFilter");

export const RESET = createActionType(MODULE, "reset");
